import { ResidenceType } from '/@/modules/asset/enums/ResidenceType';
import { AssetOwnershipMeta } from '/@/modules/asset/models/meta/AssetOwnershipMeta';

export class RealEstateMeta extends AssetOwnershipMeta {
  /**
   * @var {string}
   */
  residenceType;

  /**
   * @var {string}
   */
  ownershipType;

  /**
   * @var {?string}
   */
  policyNumber;

  /**
   * @var {?number}
   */
  homeInsuranceProviderId;

  /**
   * @var {?number}
   */
  sharePercentage;

  /**
   * @var {?string}
   */
  assessorsParcelNumber;

  /**
   * @var {?string}
   */
  legalDescription;

  constructor(model = {}) {
    super(model);
    this.residenceType = model.residenceType;
    this.ownershipType = model.ownershipType;
    this.policyNumber = model.policyNumber;
    this.homeInsuranceProviderId = model.homeInsuranceProviderId;
    this.sharePercentage = model.sharePercentage;
    this.assessorsParcelNumber = model.assessorsParcelNumber;
    this.legalDescription = model.legalDescription;
  }

  get title() {
    return ResidenceType.getByKey(this.residenceType).value;
  }

  /**
   * @var {boolean}
   */
  get hasPercentShare() {
    return this.sharePercentage >= 0 && this.sharePercentage <= 100;
  }
}
